import { z } from "zod/v4";

export const clubLocationSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	name: z.string(),
	address: z.string().nullable().optional(),
	latitude: z.number().min(-90).max(90).nullable().optional(),
	longitude: z.number().min(-180).max(180).nullable().optional(),
	sort_order: z.number().int(),
	created_at: z.coerce.date(),
});

export const createClubLocationSchema = z.object({
	name: z.string().min(1, "Name is required"),
	address: z.string().nullable().optional(),
	latitude: z.number().min(-90).max(90).nullable().optional(),
	longitude: z.number().min(-180).max(180).nullable().optional(),
	sort_order: z.number().int().optional(),
});

export const updateClubLocationSchema = z.object({
	name: z.string().min(1).optional(),
	address: z.string().nullable().optional(),
	latitude: z.number().min(-90).max(90).nullable().optional(),
	longitude: z.number().min(-180).max(180).nullable().optional(),
	sort_order: z.number().int().optional(),
});

export const clubCourtSchema = z.object({
	id: z.string().uuid(),
	club_id: z.string().uuid(),
	club_location_id: z.string().uuid(),
	name: z.string(),
	sort_order: z.number().int(),
	created_at: z.coerce.date(),
});

export const createClubCourtSchema = z.object({
	name: z.string().min(1, "Name is required"),
	sort_order: z.number().int().optional(),
});

export const updateClubCourtSchema = z.object({
	name: z.string().min(1).optional(),
	sort_order: z.number().int().optional(),
});
